import { gql } from '@apollo/client';

export const GET_LANGUAGE = gql`
    query GetLanguage(
        $id: ID
    ){
        language(
            id: $id,
        ){
            id
            label
            slug
            status
        }
    }
`;

export const GET_LANGUAGES = gql`
    query GetLanguages(
        $status: Boolean
    ){
        languages(
            status: $status,
        ){
            id
            label
            slug
            status
        }
    }
`;

export const GET_LANGUAGES_ALL = gql`
    query GetLanguagesAll(
        $status: Boolean
    ){
        languagesAll(
            status: $status,
        ){
            id
            label
            slug
            status
        }
    }
`;

export const GET_LANGUAGES_PAGINATED = gql`
    query GetLanguagesPaginated(
        $text: String,
        $where: QueryLanguagesPaginatedWhereWhereConditions,
        $orderBy: [QueryLanguagesPaginatedOrderByOrderByClause!],
        $first: Int,
        $page: Int
    ){
        languagesPaginated(
            text: $text,
            where: $where,
            orderBy: $orderBy,
            first: $first,
            page: $page
        ){
            paginatorInfo{
                total
                count
                currentPage
                perPage
                lastPage
            }
            data{
                id
                label
                slug
                status
            }
        }
    }
`;
